import React, { useId } from "react"
import {
  Box,
  Flex,
  FormLabel,
  Input,
} from "@chakra-ui/react"
import Button from "components/Buttons/Button"
import useModal from "services/useModal"
import { ModalName } from "sharedTypes"

type Props = {
  value: string
  updateEvent: (params: {}) => Promise<void> | void
  onChangeEventWorkingCopy?: (values: Record<string, any>) => void
  onResetEventWorkingCopy?: () => void
  label?: string
  labelWidth?: number | string
  inputMaxW?: number | string
  isDisabled?: boolean
  variant?: "flushed" | "outline"
  mb?: number
}

const PublicTitleRow = ({
  value,
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
  label = "Public Event Title",
  labelWidth = 1 / 4,
  inputMaxW = "md",
  isDisabled,
  variant = "flushed",
  mb = 4,
}: Props) => {
  const showModal = useModal()
  const titleInputId = useId()
  const shouldShowLabel = Boolean(label?.trim())
  const inputAriaLabel = shouldShowLabel ? undefined : (label?.trim() || "Public Event Title")

  return (
    <Flex
      alignItems="flex-start"
      flexDirection="row"
      mb={mb}
    >
      {shouldShowLabel && (
        <FormLabel
          htmlFor={titleInputId}
          w={labelWidth}
          fontSize="md"
          fontWeight="semibold"
          mt={2}
        >
          {label}
        </FormLabel>
      )}
      <Box w="100%">
        <Flex maxW={inputMaxW} gap={4}>
          <Input
            id={titleInputId}
            aria-label={inputAriaLabel}
            value={value}
            variant={variant}
            isReadOnly
            bg={variant === "outline" ? "gray.50" : "white"}
            _readOnly={{ color: "gray.500" }}
          />
          <Button
            variant="outline"
            size="md"
            isDisabled={isDisabled}
            onClick={() => showModal(ModalName.PublicEventTitle, {
              updateEvent,
              onChangeEventWorkingCopy: onChangeEventWorkingCopy ?? (() => {}),
              onResetEventWorkingCopy: onResetEventWorkingCopy ?? (() => {}),
            })}
          >
            Edit
          </Button>
        </Flex>
      </Box>
    </Flex>
  )
}

export default PublicTitleRow
